import { cn } from "@/lib/utils"
import { Skeleton } from "@/components/ui/skeleton"

export function TeamCardSkeleton() {
  return (
    <div
      className={cn(
        "flex flex-col overflow-hidden rounded-xl",
        "bg-card-surface border border-border"
      )}
    >
      <div className="relative h-28 w-full bg-muted overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-card dark:from-card-surface to-transparent" />
        <div className="absolute -bottom-6 left-4">
          <Skeleton className="size-16 rounded-xl border-4 border-background dark:border-card-surface" />
        </div>
      </div>

      <div className="flex flex-col flex-1 pt-10 px-4 pb-4 gap-4">
        <div>
          <Skeleton className="h-5 w-32 mb-2" />
          <Skeleton className="h-4 w-24" />
        </div>
        <div className="bg-muted/50 rounded-lg p-2.5 border border-border">
          <Skeleton className="h-2.5 w-16 mb-1.5" />
          <div className="flex items-center gap-2">
            <Skeleton className="size-7 rounded-lg shrink-0" />
            <div className="flex-1 space-y-1">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-auto">
          <Skeleton className="flex-1 h-8 rounded-lg" />
          <Skeleton className="h-8 w-8 rounded-lg" />
        </div>
      </div>
    </div>
  )
}
